import KatalLogger, { LoggerConfig } from '@amzn/katal-logger';

import { isRunningTest } from './Helper';
import { getEnvConfigByKey } from '../config/EnvConfig';
import { awsRum } from '../config/cloudWatchRUM';

// Katal Logger backend is currently disabled (katalLoggerUrl is '' in EnvConfig.ts).
// With an empty URL, KatalLogger skips the HTTP POST and only outputs to the
// browser console (logToConsole: true). Error-level events are still forwarded
// to CloudWatch RUM via the RumLogger wrapper below.
// See the NOTE in EnvConfig.ts for context and instructions to revive the backend.
const loggerConfig: LoggerConfig = {
  url:
    getEnvConfigByKey('katalLoggerUrl') ||
    process.env.REACT_APP_KATAL_LOGGER_URL ||
    '',
  context: {
    sessionUserID: window.localStorage.getItem(
      'PerformancePortalService_sessionID'
    ),
  },
  logToConsole: !isRunningTest(), // we will also log to console in addition to backend logger
};

class RumLogger extends KatalLogger {
  async error(
    message: string,
    errorOrContext?: Error | Record<string, any>,
    context?: Record<string, any>
  ): Promise<void> {
    // Determine if second parameter is Error or context, as katal's logger function is overloaded
    const isError = errorOrContext instanceof Error;
    const error = isError ? errorOrContext : undefined;
    const actualContext = isError ? context : errorOrContext;

    // Always call awsRum?.recordError
    awsRum?.recordError(error ?? message);

    if (error) {
      await super.error(message, error, actualContext);
    } else {
      await super.error(message, actualContext);
    }
  }
}

export const logger = new RumLogger(loggerConfig);
